module.exports = __webpack_public_path__ + "static/media/kz.740ef4bf.svg";